import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyaryoSyozokuListGetReq,
  TSyaryoSyozokuToPostReq,
  TSyaryoSyozokuToPutReq,
  TSyaryoSyozokuFromPutReq,
  TSyaryoSyozokuInfoGetRes,
  TSyaryoSyozokuPutReq,
} from "./TSyaryoSyozoku"

/**
 * 車輌所属マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class SyaryoSyozokuService
 * @extends {ConnectApi}
 */
export default class SyaryoSyozokuService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyaryoSyozokuListGetReq} params
   * @memberof SyaryoSyozokuService
   */
  getList = async (params: TSyaryoSyozokuListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoSyozokuInfoGetRes[]>> =
        await this.getInner(`/truck/syaryosyozoku`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {number} id
   * @memberof SyaryoSyozokuService
   */
  getSyaryoSyozoku = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoSyozokuInfoGetRes>> =
        await this.getInner(`truck/syaryosyozoku/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録(異動先)
   *
   * @param {TSyaryoSyozokuToPostReq} data
   * @memberof SyaryoSyozokuService
   */
  postSyaryoSyozokuTo = async (
    id: string | number,
    data: TSyaryoSyozokuToPostReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `truck/syaryosyozoku/register/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新(異動先)
   *
   * @param {TSyaryoSyozokuToPutReq} data
   * @memberof SyaryoSyozokuService
   */
  putSyaryoSyozokuTo = async (
    id: string | number,
    data: TSyaryoSyozokuToPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truck/syaryosyozoku/update/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新(現在)
   *
   * @param {TSyaryoSyozokuFromPutReq} data
   * @memberof SyaryoSyozokuService
   */
  putSyaryoSyozokuFrom = async (
    id: string | number,
    data: TSyaryoSyozokuFromPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truck/syaryosyozoku/from/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TSyaryoSyozokuPutReq} data
   * @memberof SyaryoSyozokuService
   */
  putSyaryoSyozoku = async (
    id: string | number,
    data: TSyaryoSyozokuPutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truck/syaryosyozoku/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
